export enum Behaeltergeometrien {
  RECHTECKIG = 72,
  RUND = 71,
}
